module.exports = __webpack_public_path__ + "img/kumo_white_1.f1610b06.svg";